import React, { useEffect } from 'react';
import { useAppNavigationContext } from '../../app/features/navigation/providers/AppNavigationProvider';
import PDocumentFile from './pages/PDocumentFile';
import PDocumentDashboard from './pages/PDocumentDashboard';
import PDocumentExpertise from './pages/PDocumentExpertise';
import PDocumentSearch from './pages/PDocumentSearch';
import PDocumentFund from './pages/PDocumentFund';
import PDocumentCompany from './pages/PDocumentCompany';

type DocumentProps = {
	page: string;
};
const Document = (props: DocumentProps) => {
	const { page } = props;

	const navigationContext = useAppNavigationContext();
	useEffect(() => {
		if (navigationContext.displayCurrencySelector === true) {
			navigationContext.setDisplayCurrencySelector(false);
		}
	}, [navigationContext]);

	switch (page) {
		case 'dashboard':
			return <PDocumentDashboard />;
		case 'documents_expertise':
			return <PDocumentExpertise />;
		case 'documents_fund':
			return <PDocumentFund />;
		case 'documents_company':
			return <PDocumentCompany />;
		case 'documents_search':
			return <PDocumentSearch />;
		case 'document':
			return <PDocumentFile />;
		default:
			return <></>;
	}
};

export default Document;
